module.exports = __webpack_public_path__ + "img/visa.199bf438.svg";